import { useTranslation } from '@/i18n';
import { IconAi, Tag } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './AiSuggestSummaryBanner.module.scss';

const cx = classnames.bind(styles);

/**
 * AI Suggest success label shown above 基本情報 when AI Suggest processed the
 * report successfully but returned no reference report. A blue "AIサジェスト" Tag
 * (mirrors AiSuggestFailureLabel's Tag, with the success/blue status + AI icon).
 */
const InnerAiSuggestSuccessLabel: FC = () => {
  const { t } = useTranslation();

  return (
    <span className={cx('success')}>
      <Tag
        status='success'
        closable={false}
        outline={false}
        size='default'
        customIcon={<IconAi size={12} />}
      >
        {t('received_invoice.ai_suggest_label')}
      </Tag>
    </span>
  );
};

InnerAiSuggestSuccessLabel.displayName = 'InnerAiSuggestSuccessLabel';

export const AiSuggestSuccessLabel: FC = memo(InnerAiSuggestSuccessLabel);
AiSuggestSuccessLabel.displayName = 'AiSuggestSuccessLabel';
